import apiHelpers from './apiHelpers';

export default {
    getPostbacks() {
        return apiHelpers.httpRequest('postbacks', {}, 'get');
    },
    addPostback(body) {
        return apiHelpers.httpRequest('postbacks', body, 'post');
    },
    deletePostback(id) {
        return apiHelpers.httpRequest(`postbacks/${id}`, {}, 'delete');
    },

};
